// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3OVi_","item":"PaymentsMobile_item__2XNCx","label":"PaymentsMobile_label__1kc_0","amount":"PaymentsMobile_amount__FZ1dd"};